// extracted by css-extract-rspack-plugin
export default {"copy":"copy-QgMNPX"};